<template>
  <v-textarea
    v-bind:value="value"
    :error-messages="errors"
    :label="label"
    :hint="hint"
    :readonly="readonly"
    :rows="rows"
    :clearable="readonly ? false : true"
    :auto-grow="autoGrow"
    class="a-textarea"
    hide-details="auto"
    :prepend-inner-icon="prependInnerIcon"
    @input="$emit('input', $event)"
  ></v-textarea>
</template>

<script>
/**
 * @vue-prop {String} value - Value
 * @vue-prop {Object} validator - Validator
 * @vue-prop {String} label - Label
 * @vue-prop {String} hint - Hint
 * @vue-prop {Boolean} readonly - Read only
 * @vue-prop {Boolean} autoGrow - Auto grow
 * @vue-prop {String} rows - Rows
 * @vue-prop {String} prependInnerIcon - Icon
 * @vue-computed {String} errors
 */
export default {
  name: "a-textarea",

  props: {
    value: String,
    validator: Object,
    label: String,
    hint: String,
    readonly: Boolean,
    autoGrow: Boolean,
    rows: String,
    prependInnerIcon: String
  },

  computed: {
    errors() {
      const errors = [];

      if (!this.validator || !this.validator.$dirty) return errors;

      typeof this.validator.required !== "undefined" &&
        !this.validator.required &&
        errors.push(this.$t("errors.fields.REQUIRED_FIELD"));

      typeof this.validator.minLength !== "undefined" &&
        !this.validator.minLength &&
        errors.push(
          this.$t("errors.fields.FIELD_MIN_CHAR", {
            min: this.validator.$params.minLength.min
          })
        );

      typeof this.validator.maxLength !== "undefined" &&
        !this.validator.maxLength &&
        errors.push(
          this.$t("errors.fields.FIELD_MAX_CHAR", {
            max: this.validator.$params.maxLength.max
          })
        );

      return errors;
    }
  }
};
</script>
